export default __webpack_public_path__ + "static/media/image.b3643019.svg";